export default {
  // Hero Section
  'hero.title': 'Die Zukunft des Sports ist digital',
  'hero.subtitle': 'Wir revolutionieren die Sportbranche durch innovative digitale Lösungen, die Athleten, Fans und Marken auf völlig neue Weise verbinden.',
  'hero.cta': 'Jetzt dabei sein',
  'hero.learnMore': 'Mehr erfahren',
  
  // The Idea
  'idea.title': 'Die Idee',
  'idea.subtitle': 'Eine Vision, die den Sport für immer verändert',
  'idea.description': 'Stellen Sie sich eine Welt vor, in der jeder Fan direkten Zugang zu seinen Lieblingssportlern hat. Wo digitale Technologien nicht nur die Art und Weise verändern, wie wir Sport konsumieren, sondern auch wie Athleten mit ihrer Community interagieren und davon profitieren.',
  'idea.point1Title': 'Direkte Verbindung',
  'idea.point1Desc': 'Fans können direkt mit ihren Idolen kommunizieren und exklusive Inhalte erhalten',
  'idea.point2Title': 'Neue Einnahmequellen',
  'idea.point2Desc': 'Athleten erschließen innovative Monetarisierungsmöglichkeiten jenseits traditioneller Sponsoring-Deals',
  'idea.point3Title': 'Community-Driven',
  'idea.point3Desc': 'Eine lebendige Community, die gemeinsam wächst und vom Erfolg profitiert',
  'idea.exampleTitle': 'Ein konkretes Beispiel gefällig?',
  'idea.exampleDesc': 'Entdecken Sie ein Projekt, das bereits über 1 Million aktive Nutzer hat und dessen Token-Bewertung auf über 100$ steigen könnte.',
  'idea.exampleCta': 'Erfolgsgeschichte ansehen',
  
  // Fan Economy
  'fanEconomy.title': 'Die Fan-Economy',
  'fanEconomy.subtitle': 'Wenn Leidenschaft auf Innovation trifft',
  'fanEconomy.intro': 'Die Sportindustrie steht vor einem Paradigmenwechsel. Fans wollen mehr als nur Zuschauer sein – sie wollen Teil der Geschichte werden.',
  'fanEconomy.stat1': 'Milliarden',
  'fanEconomy.stat1Label': 'Globale Sportfans',
  'fanEconomy.stat2': 'Milliarden $',
  'fanEconomy.stat2Label': 'Marktvolumen',
  'fanEconomy.stat3': '%',
  'fanEconomy.stat3Label': 'Jährliches Wachstum',
  'fanEconomy.trend1Title': 'Digitale Transformation',
  'fanEconomy.trend1Desc': 'Der Sport wird zunehmend digital – von NFTs bis zu virtuellen Erlebnissen',
  'fanEconomy.trend2Title': 'Direct-to-Fan',
  'fanEconomy.trend2Desc': 'Athleten bauen direkte Beziehungen zu ihren Fans auf, ohne Mittelsmänner',
  'fanEconomy.trend3Title': 'Tokenisierung',
  'fanEconomy.trend3Desc': 'Fans können in ihre Lieblingssportler investieren und am Erfolg teilhaben',
  
  // Digital Giants
  'giants.title': 'Die digitalen Giganten',
  'giants.subtitle': 'Erfolgsgeschichten, die den Weg weisen',
  'giants.intro': 'Große Plattformen haben bereits bewiesen, dass die Verbindung von Sport, Community und digitalen Assets funktioniert:',
  'giants.socios.title': 'Socios.com',
  'giants.socios.desc': 'Die weltweit führende Plattform für Fan-Token hat über 2 Millionen Nutzer und Partnerschaften mit Top-Clubs wie FC Barcelona, PSG und Juventus Turin.',
  'giants.socios.stat1': '2M+',
  'giants.socios.stat1Label': 'Aktive Nutzer',
  'giants.socios.stat2': '100+',
  'giants.socios.stat2Label': 'Partner-Clubs',
  'giants.socios.stat3': '$400M+',
  'giants.socios.stat3Label': 'Handelsvolumen',
  'giants.sorare.title': 'Sorare',
  'giants.sorare.desc': 'Das Fantasy-Football-Spiel mit NFT-Karten hat die Branche revolutioniert und eine Bewertung von über 4 Milliarden Dollar erreicht.',
  'giants.sorare.stat1': '5M+',
  'giants.sorare.stat1Label': 'Registrierte Nutzer',
  'giants.sorare.stat2': '300+',
  'giants.sorare.stat2Label': 'Lizenzierte Ligen',
  'giants.sorare.stat3': '$4.3B',
  'giants.sorare.stat3Label': 'Unternehmenswert',
  'giants.nba.title': 'NBA Top Shot',
  'giants.nba.desc': 'Die offizielle NBA-Plattform für digitale Sammelkarten hat Millionen von Fans begeistert und über 1 Milliarde Dollar Umsatz generiert.',
  'giants.nba.stat1': '1M+',
  'giants.nba.stat1Label': 'Sammler',
  'giants.nba.stat2': '$1B+',
  'giants.nba.stat2Label': 'Gesamtumsatz',
  'giants.nba.stat3': '20M+',
  'giants.nba.stat3Label': 'Verkaufte NFTs',
  
  // Digital Revolution
  'revolution.title': 'Die digitale Revolution im Sport',
  'revolution.subtitle': 'Warum jetzt der perfekte Zeitpunkt ist',
  'revolution.reason1Title': 'Technologie ist bereit',
  'revolution.reason1Desc': 'Blockchain, NFTs und digitale Wallets sind ausgereift und massentauglich geworden',
  'revolution.reason2Title': 'Fans fordern mehr',
  'revolution.reason2Desc': 'Die neue Generation will Teilhabe, Interaktion und echten Mehrwert',
  'revolution.reason3Title': 'Athleten suchen Alternativen',
  'revolution.reason3Desc': 'Traditionelle Sponsoring-Modelle reichen nicht mehr aus',
  'revolution.reason4Title': 'Marken investieren',
  'revolution.reason4Desc': 'Große Brands erkennen das Potenzial und investieren Milliarden',
  'revolution.quote': 'Die Zukunft des Sports liegt in der direkten Verbindung zwischen Athleten und Fans. Wer jetzt nicht handelt, verpasst die größte Chance der letzten Dekade.',
  'revolution.quoteAuthor': 'Sportindustrie-Analyst',
  
  // Target Groups
  'target.title': 'Für wen ist das interessant?',
  'target.subtitle': 'Verschiedene Perspektiven, ein gemeinsames Ziel',
  'target.athletes.title': 'Athleten & Sportler',
  'target.athletes.benefit1': 'Neue Einnahmequellen erschließen',
  'target.athletes.benefit2': 'Direkte Verbindung zur Fan-Community',
  'target.athletes.benefit3': 'Unabhängigkeit von traditionellen Sponsoren',
  'target.athletes.benefit4': 'Langfristiger Vermögensaufbau',
  'target.investors.title': 'Investoren & Unternehmer',
  'target.investors.benefit1': 'Zugang zu einem Milliardenmarkt',
  'target.investors.benefit2': 'Frühe Beteiligung an Innovation',
  'target.investors.benefit3': 'Diversifikation des Portfolios',
  'target.investors.benefit4': 'Exponentielles Wachstumspotenzial',
  'target.brands.title': 'Marken & Sponsoren',
  'target.brands.benefit1': 'Authentische Zielgruppenansprache',
  'target.brands.benefit2': 'Messbare Marketing-Erfolge',
  'target.brands.benefit3': 'Innovative Kooperationsmodelle',
  'target.brands.benefit4': 'Zugang zu engagierten Communities',
  'target.creators.title': 'Creator & Influencer',
  'target.creators.benefit1': 'Monetarisierung der Reichweite',
  'target.creators.benefit2': 'Exklusive Content-Möglichkeiten',
  'target.creators.benefit3': 'Community-Building-Tools',
  'target.creators.benefit4': 'Passive Einkommensströme',
  
  // Exclusive Access
  'exclusive.title': 'Exklusiver Zugang',
  'exclusive.subtitle': 'Seien Sie Teil der digitalen Sport-Revolution',
  'exclusive.description': 'Wir suchen ausgewählte Partner, Investoren und Visionäre, die gemeinsam mit uns die Zukunft des Sports gestalten wollen. Die Plätze sind limitiert.',
  'exclusive.feature1Title': 'Early Access',
  'exclusive.feature1Desc': 'Erhalten Sie als Erste Zugang zu neuen Projekten und Möglichkeiten',
  'exclusive.feature2Title': 'Exklusive Insights',
  'exclusive.feature2Desc': 'Detaillierte Analysen, Marktdaten und Insider-Informationen',
  'exclusive.feature3Title': 'Persönliche Beratung',
  'exclusive.feature3Desc': 'Direkter Kontakt zu unserem Team und individuelles Onboarding',
  'exclusive.feature4Title': 'Netzwerk',
  'exclusive.feature4Desc': 'Zugang zu einem exklusiven Netzwerk von Gleichgesinnten',
  'exclusive.cta': 'Jetzt registrieren',
  'exclusive.ctaSecondary': 'Das Projekt entdecken',
  'exclusive.limited': 'Nur noch wenige Plätze verfügbar',
  
  // Lead Form
  'form.title': 'Jetzt unverbindlich',
  'form.titleHighlight': 'Informationen',
  'form.titleEnd': 'anfordern',
  'form.name': 'Name',
  'form.namePlaceholder': 'Dein vollständiger Name',
  'form.email': 'E-Mail',
  'form.emailPlaceholder': 'deine@email.com',
  'form.country': 'Land',
  'form.countryPlaceholder': 'Deutschland',
  'form.role': 'Rolle',
  'form.rolePlaceholder': 'Bitte wählen...',
  'form.roleAthlete': 'Spieler / Athlet',
  'form.roleAgent': 'Berater / Vermittler',
  'form.roleInvestor': 'Unternehmer / Investor',
  'form.roleBrand': 'Marke / Sponsor',
  'form.roleCreator': 'Creator / Influencer',
  'form.roleOther': 'Sonstiges',
  'form.interest': 'Was interessiert dich an der Digitalisierung im Sport?',
  'form.interestPlaceholder': 'Erzähle uns von deinen Interessen und Zielen...',
  'form.privacy': 'Ich habe die',
  'form.privacyLink': 'Datenschutzerklärung',
  'form.privacyText': 'zur Kenntnis genommen. Ich stimme zu, dass meine Angaben zur Kontaktaufnahme und für Rückfragen dauerhaft gespeichert werden.',
  'form.submit': 'Anfrage senden',
  'form.submitting': 'Wird gesendet...',
  'form.disclaimer': 'Wir prüfen jede Anfrage individuell und melden uns persönlich,',
  'form.disclaimerLine2': 'wenn dein Profil zum aktuellen Projekt passt.',
  'form.required': '*',
  'form.charCount': 'Zeichen',
  
  // Thank You
  'thanks.title': 'Vielen Dank!',
  'thanks.subtitle': 'Ihre Anfrage wurde erfolgreich übermittelt',
  'thanks.message': 'Wir haben Ihre Informationen erhalten und werden uns in Kürze bei Ihnen melden. Bitte überprüfen Sie auch Ihren Spam-Ordner.',
  'thanks.nextSteps': 'Nächste Schritte:',
  'thanks.step1': 'Wir prüfen Ihr Profil',
  'thanks.step2': 'Sie erhalten eine persönliche Rückmeldung',
  'thanks.step3': 'Bei Interesse vereinbaren wir ein Gespräch',
  'thanks.backHome': 'Zurück zur Startseite',
};